angular.module('rjmNg.controllers').controller('bulkEditCtrl', [
  "$scope"
  "dashboardService"
  "$route"
  "$routeParams"
  "Charts"
  "figureService"
  "Figures"
  "dateService"
  "namedDates"
  "timeRangeEnums"
  "$rootScope"
  "utils"
  "logger"
  "app"
  "BulkEdit"
  ($scope, dashboardService, $route, $routeParams, Charts, figureService,
  Figures, dateService, namedDates, timeRangeEnums, $rootScope, utils,
  logger, app, BulkEdit) ->
    # Initialize the model
    $scope.startDate = namedDates.NO_CHANGE
    $scope.endDate = namedDates.NO_CHANGE
    $scope.timeInterval = namedDates.NO_CHANGE
    $scope.meta =
      prependToName: ''
      findInName: ''
      replaceInName: ''
    $scope.intervals = [namedDates.NO_CHANGE].concat timeRangeEnums.TIME_INTERVALS
    $scope.totalCharts = dashboardService.dashboard.dashboardItems.length
    $scope.updatedCharts = 0
    $scope.totalCharts = 1
    $scope.skippedCharts = []
    $scope.erroredCharts = []
    $scope.error = ''
    $scope.loadingError = ''
    $scope.canBulkEditTimeOptions = not app.hasFeatureFlag('DASHBOARD_WIDE_TIME_RANGES')

    # Check to make sure the end date is after the start date
    $scope.$watch 'startDate + endDate', () ->
      startDate = new Date($scope.startDate)
      endDate = new Date($scope.endDate)

      if endDate < startDate
        $scope.error = 'The end date must be after the start date'
      else
        $scope.error = ''

    $scope.doneLoadingCharts = () ->

      chartsLoaded = true

      for item in dashboardService.dashboard.dashboardItems
        if item.chart is undefined
          if item.figure?
            continue
          else
            $scope.loadingError = 'Please wait until all charts load'
            return false

      $scope.loadingError = ''
      return true

    # Accepts a string and checks to see if this would evaluate to a proper date.
    $scope.isValidDate = (dateString) ->
      date = new Date(dateString)
      return not isNaN(date.getTime())

    # Submit the charts to be edited
    $scope.bulkEdit = (modal) ->
      logger.log('Bulk Edit Reports Modal Usage', 'Save', 1, 'edit')
      $scope.bulkEditRunning = true

      # Reset some variables
      $scope.totalCharts = dashboardService.dashboard.dashboardItems.length
      $scope.updatedCharts = 0

      if _onlyModifyingNames()
        _runNameOnlyModifications(modal)
        return

      dashboardItems = dashboardService.dashboard.dashboardItems

      # Check to see if all the charts have loaded first
      if $scope.doneLoadingCharts()

        # Update the charts
        for dashboardItem in dashboardItems
          chart = dashboardItem.chart
          figure = dashboardItem.figure
          # Update every chart we can with the new data

          # Check to see if this is a GA chart
          isGa = chart?.api_conn_id?

          if chart? and chart.series[0].trend.timestampColumn isnt null
            _processChart(chart, modal)
          else if figure? and not chart? and figure.reportQueryType isnt 'sql'
            _processFigure(figure, modal)
          else
            # Mark this as complete, even though we skipped it
            $scope.skippedCharts.push(if chart? then chart.name else figure?.name)

      $rootScope.$broadcast('reloadRjqlFigure', null)
      return

    _onlyModifyingNames = () ->
      prependingToName = $scope.meta.prependToName.length > 0
      replacingInName = $scope.meta.findInName.length > 0
      editingDates = $scope.startDate isnt namedDates.NO_CHANGE \
                     or $scope.endDate isnt namedDates.NO_CHANGE \
                     or $scope.timeInterval isnt namedDates.NO_CHANGE
      return (prependingToName or replacingInName) and not editingDates

    # The new route in the dashboard service for bulk editing currently only
    # supports name modifications. The most straightforward way to use this
    # functionality is to only use it when the user is not trying to do any
    # date modifications. In the future it would be probably be best to move
    # the date modification code into the route and remove the code in here
    # that tries to handle that. Or maybe the date modification can be removed
    # entirely with the new dashboard-wide-filtering coming out.
    _runNameOnlyModifications = (modal) ->
      if $scope.meta.prependToName.length > 0
        logger.log('Bulk Edit Reports Prepend Names Usage', 'Save', 1, 'edit')
      if $scope.meta.findInName.length > 0
        logger.log('Bulk Edit Reports Find and Replace Usage', 'Save', 1, 'edit')
      payload =
        prepend_to_name: $scope.meta.prependToName
        find_in_name: $scope.meta.findInName
        replace_in_name: $scope.meta.replaceInName
      BulkEdit($routeParams.dashId).post(payload).then(
        () =>
          $scope.updatedCharts = dashboardService.dashboard.dashboardItems.length
          $scope.close(modal)
          $rootScope.$broadcast('reloadRjqlFigure', null)
        ,
        (data, status) =>
          $scope.error = 'There was an error performing the bulk edit, ' + \
            'please reload and try again or contact support'
      )

    _processFigure = (oldFigure, modal) ->
      figure = utils.copy(oldFigure)
      if $scope.meta.findInName.length > 0
        figure.name = figure.name.replace($scope.meta.findInName, $scope.meta.replaceInName)
        logger.log('Bulk Edit Reports Find and Replace Usage', 'Save', 1, 'edit')

      if $scope.meta.prependToName.length > 0
        figure.name = $scope.meta.prependToName + figure.name
        logger.log('Bulk Edit Reports Prepend Names Usage', 'Save', 1, 'edit')

      # Get the timerange of this figure
      originalTimeRange = figureService.getTimeRangeFromFigure(figure)
      revisedTimeRange = dateService.getStaticTimeRange($scope.startDate, $scope.endDate, app.getRjqlVersion())

      # Don't overwrite anything we want to keep
      if $scope.startDate is namedDates.NO_CHANGE or not _canChangeDate(figure, revisedTimeRange)
        revisedTimeRange.start = originalTimeRange.start
      else
        logger.log('Bulk Edit Reports Start Date Usage', 'Save', 1, 'edit')

      if $scope.endDate is namedDates.NO_CHANGE or not _canChangeDate(figure, revisedTimeRange)
        revisedTimeRange.end = originalTimeRange.end
      else
        logger.log('Bulk Edit Reports End Date Usage', 'Save', 1, 'edit')

      # Grab the time interval
      originalTimeInterval = figureService.getTimeInterval(figure)

      # If we don't use a time interval (e.g scalars) don't add one.
      if originalTimeInterval isnt 'None' and $scope.timeInterval isnt namedDates.NO_CHANGE
        column.interval = $scope.timeInterval for column in figure.query.select.columns when column.time.indexOf('time') > -1
        logger.log('Bulk Edit Reports Time Interval Usage', 'Save', 1, 'edit')

      figure.query.timerange = revisedTimeRange
      $scope.updateFigure(figure, modal)

    # In certain cases we can't change the date
    _canChangeDate = (figure, timeRange) ->
      staticRange = (timeRange.start.type is 'static' and timeRange.end.type is 'static')
      # GA charts must have static ranges
      if figureService.containsGaMetric(figure) and not staticRange
        return false
      else
        return true

    _processChart = (chart, modal) ->
      if $scope.meta.findInName.length > 0
        chart.name = chart.name.replace($scope.meta.findInName, $scope.meta.replaceInName)

      if $scope.meta.prependToName.length > 0
        chart.name = $scope.meta.prependToName + chart.name

      # Clone the timeframe of this chart
      timeFrame = _.clone(chart.timeFrame)

      # Set our start date
      timeFrame = $scope.setStartDate(timeFrame, $scope.startDate)

      # Set our end date
      timeFrame = $scope.setEndDate(timeFrame, $scope.endDate)

      # Make any additional modifications to the time frame or set it back
      chart.timeFrame = $scope.correctTimeFrame(timeFrame, chart.timeFrame)

      # If we don't use a time interval (e.g scalars) don't add one.
      if $scope.timeInterval isnt namedDates.NO_CHANGE and chart.isTimeOnXAxis
        chart.timeInterval = $scope.timeInterval.toUpperCase()

      # Now hit the end point

      $scope.updateChart(chart, modal)

    # Accepts a timeFrame object and a start date string and returns the appropriate object
    $scope.setStartDate = (timeFrame, startDate) ->
      switch startDate
        when namedDates.NO_CHANGE
          timeFrame = timeFrame
        when namedDates.OLDEST
          timeFrame.start = null
        when null
          timeFrame.start = null
          timeFrame.endUnbounded = false
        when false
          timeFrame.start = null
          timeFrame.endUnbounded = false
        else
          timeFrame.start = startDate
          timeFrame.type = 'SPECIFIC'
          timeFrame.endUnbounded = false

      return timeFrame

    # Accepts a timeFrame object and an end date string and returns the appropriate object
    $scope.setEndDate = (timeFrame, endDate) ->
      switch endDate
        when namedDates.NO_CHANGE
          timeFrame = timeFrame
        when namedDates.NOW
          timeFrame.end = null
          timeFrame.endUnbounded = false
        when null
          timeFrame.end = null
          timeFrame.endUnbounded = false
        when false
          timeFrame.end = null
          timeFrame.endUnbounded = false
        else
          timeFrame.end = endDate
          timeFrame.type = 'SPECIFIC'
          timeFrame.endUnbounded = false

      return timeFrame

    # Now that we've changed our timeFrame, check to see if it conforms.  Modify it or abort and send back the old one
    $scope.correctTimeFrame = (newTimeFrame, oldTimeFrame) ->
      # Are we using all time?
      if (newTimeFrame.start is null and newTimeFrame.end is null)

        # Simplify the timeFrame object
        newTimeFrame = { 'type' : 'ALL_TIME' }

      else if newTimeFrame.start isnt null and newTimeFrame.end isnt null

        startDate = new Date(newTimeFrame.start)
        endDate = new Date(newTimeFrame.end)

        # The end date should come after the start date
        if endDate < startDate
          # If this newTimeFrame breaks the chart's time period, send back the old one
          newTimeFrame = oldTimeFrame

      return newTimeFrame

    $scope.updateFigure = (figure, modal) ->
      if not $scope.canBulkEditTimeOptions
        figure.query = null
      # Now hit the end point
      Figures.save(figure).then(
        (result) =>
          options = Figures.getRequestOptions(true, true)
          if $routeParams.dashId?
            options.params.dashboardId = $routeParams.dashId
          Figures.get(figure.id, true, options)
          _handleSuccess(result, figure.name, modal)
        ,
        (data, status) =>
          _handleError(data, status, figure.name)
      )

     $scope.updateChart = (chart, modal) ->
      Charts.save(chart).then(
        (result) =>
          _handleSuccess(result, chart.name, modal)
      ,
        (data, status) =>
          _handleError(data, status, chart.name)
      )

    $scope.close = (modal) ->
      $scope.error = ''
      $scope.bulkEditRunning = false
      modal('hide')
      if $scope.updatedCharts > 0
        $route.reload()

    _handleSuccess = (result, name, modal) ->
      $scope.updatedCharts += 1
      # If we updated or skipped everything with no errors, close the modal
      if $scope.updatedCharts >= $scope.totalCharts and $scope.skippedCharts.length < 1
        modal('hide')
        $scope.bulkEditRunning = false
        $route.reload()

    _handleError = (data, status, name) ->
      $scope.erroredCharts.push(name)
])
